// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a0ab10f6","732":"24bdd26d","977":"92962d4d"}[chunkId] + ".chunk.js";
};